import { z } from 'zod';
/** A bounded page of source-row balances, never a reconstructed ledger balance. */
export const BankStatementSourceBalancesInputSchema = z.strictObject({
    rowIndexes: z.array(z.number().int().nonnegative()).min(1).max(100),
});
export const BankStatementSourceBalancesSchema = z.object({
    balances: z.array(z.object({ rowIndex: z.number().int().nonnegative(), balanceMinorUnits: z.number().int().nullable() })),
});
